export enum MessageRole {
  User = 'user',
  Assistant = 'assistant',
  System = 'system',
}

export interface MessagePart {
  text: string;
  type: 'text';
}

export interface Message {
  id: string;
  role: MessageRole;
  parts: MessagePart[];
  content: string;
  createdAt: Date;
  revisionId?: string;
}

export interface AiChat {
  id: string;
  userId: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  messages: Message[];
}
